export const GET_WEBHOOK_LIST = 'GET_WEBHOOK_LIST'
export const GET_ACTIVE_SHEETS = 'GET_ACTIVE_SHEETS'
export const GET_SHEET_COLUMNS = 'GET_SHEET_COLUMNS'
export const GET_WORKSPACES = 'GET_WORKSPACES'
export const CHECK_MISSING_COLUMNS = 'CHECK_MISSING_COLUMNS'
export const RESET_FORM = 'RESET_FORM'
export const RESET_SUCCESS_MESSAGE = 'RESET_SUCCESS_MESSAGE'
